/**
 * Web Vital(LCP element·CLS shift source 등)의 DOM 노드를
 * Sentry 태그용 짧은 셀렉터(`tag#id.class`)로 요약한다.
 * Element가 아니면(텍스트 노드·null) 빈 문자열.
 */
export const describeElement = (node: Node | null | undefined): string => {
  if (!(node instanceof Element)) {
    return '';
  }

  const tag = node.tagName.toLowerCase();
  const id = node.id ? `#${node.id}` : '';
  // SVG 요소의 className은 SVGAnimatedString이라 string일 때만 사용
  const className =
    typeof node.className === 'string' ? node.className.trim() : '';
  const firstClass = className ? `.${className.split(/\s+/)[0]}` : '';

  return `${tag}${id}${firstClass}`;
};
